module.exports = __webpack_public_path__ + "img/action-3.2bebc404.svg";